import { render } from "./FloatingCartComponent.vue?vue&type=template&id=79322164&scoped=true"
import script from "./FloatingCartComponent.vue?vue&type=script&lang=js"
export * from "./FloatingCartComponent.vue?vue&type=script&lang=js"

import "./FloatingCartComponent.vue?vue&type=style&index=0&id=79322164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79322164"]])

export default __exports__